import { Injectable } from "@angular/core";
import { BASEMysqlService } from "./_base";
@Injectable({
  providedIn: 'root'
})
export class MysqlServiceConti extends BASEMysqlService {

    prefix = 'conti_'
  
    //////////////////////////////////////////////////////////////////////////////////////////
  
    list(): Promise<any> {
      let data = {
        auth: this.getAuth(),
      }
    
      return this.http.post(this.URL_BASE + this.prefix + 'list', data).toPromise();
    }
  /*
    get(id): Promise<any> {
      let data = {
        auth: this.getAuth(),
        id: id
      }
  
      // console.log(data)
  
      return this.http.post(this.URL_BASE + this.prefix + 'get', data).toPromise();
    }
  
    upsert(item: IAzienda): Promise<any> {
      let data = {
        auth: this.getAuth(),
        item: item
      }
  
      return this.http.post<IAzienda[]>(this.URL_BASE + this.prefix + 'upsert', data).toPromise();
    }
  
    delete(id: number): Promise<any> {
      let data = {
        auth: this.getAuth(),
        id: id
      }
  
      return this.http.post(this.URL_BASE + this.prefix + 'delete', data).toPromise();
    }
  */
  }